export enum PartNumberType {
  CPN = 'companyPartNumber', MPN = 'manufacturerPartNumber',
}

export class PartNumber {
  partNumber: string;
  type: PartNumberType;

  constructor(partNumber: string, type: PartNumberType) {
    this.partNumber = partNumber;
    this.type = type;
  }
}
